import { InjectionKey } from 'vue';
import { RetailerImportMappingViewService } from '../import-mapping.view.service';

export const importMappingServiceKey = Symbol() as InjectionKey<RetailerImportMappingViewService>;
